import { useSelector } from 'react-redux';

import { loginTypes } from 'config/loginTypes';
import { IS_IFRAME_MODE } from 'config/envVariable';
import useRetrieveThirdPartyData from 'hooks/useRetrieveThirdPartyData';
import { THIRD_PARTY_PLATFORM_KEYS } from 'config/thirdParty';

export default function useLogoutRedirect() {
    const { loginMethod } = useSelector(s => s.settingPromo);
    const { domainMappingFE = '' } = useSelector(s => s.partner);
    const { enterpriseLoginAppLogoutUrl } = useRetrieveThirdPartyData({
        platform: THIRD_PARTY_PLATFORM_KEYS.FEVERSOCIAL
    });

    if (loginMethod === loginTypes.ENTERPRISELOGIN && Boolean(enterpriseLoginAppLogoutUrl)) {
        return () => {
            let targetUrl = `${enterpriseLoginAppLogoutUrl}${encodeURIComponent(
                window.location.href
            )}`;

            if (IS_IFRAME_MODE) {
                targetUrl = `${enterpriseLoginAppLogoutUrl}${encodeURIComponent(
                    `https://${domainMappingFE}/promotions/checklogout`
                )}`;

                const width = 600;
                const height = 700;
                const left = window.screen.width / 2 - width / 2;
                const top = window.screen.height / 2 - height / 2;
                window.open(
                    targetUrl,
                    '_blank',
                    `menubar=0,resizable=0,width=${width},height=${height},top=${top},left=${left}`
                );
            } else window.location.href = targetUrl;
        };
    }
    return false;
}
